import React, { Component } from 'react';
import {Container, Row, Col, Card, CardTitle, CardBody, CardFooter, Button, Input, InputGroup, InputGroupAddon} from 'reactstrap';
import { app } from '../../base'

function ShowMessage(props) {
  return <div className="alert alert-info" role="alert" style={{display:props.show}}>{props.message}</div>;
}

class Form extends Component {
  constructor(props) {
    super(props)
    this.state = {
      message: '',
      show: 'none'
    }
  }

  formSubmit(event) {
    event.preventDefault()

    const city = this.cityInput.value
    const province = this.provinceInput.value
    const neighborhood = this.neighborhoodInput.value
    const street = this.streetInput.value
    const areaCode = this.areaCodeInput.value
    //console.log(city+"-"+province+"-"+neighborhood+"-"+street+"-"+areaCode)

    if (city == '' || province == '' || neighborhood == '' || street == '' || areaCode == '') {
      this.setMessage('All fields must be filled');
      return;
    }

    app.database().ref('locations').push().set({
      area_code: areaCode.toUpperCase(),
      city: city.toUpperCase(),
      neighborhood: neighborhood.toUpperCase(),
      province: province.toUpperCase(),
      street: street.toUpperCase()
    }).then(()=>{
      this.setMessage('Location saved');
      this.entryForm.reset()
    }).catch((error)=>{
      this.setMessage(error.message);
    });
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row className="justify-content-center">
            <Col md="6">
              <Card className="mx-4">
                <CardBody className="p-4">
                  <ShowMessage show={this.state.show} message={this.state.message} />
                  <form onSubmit={(event) => { this.formSubmit(event) }} ref={(form) => { this.entryForm = form }}>
                    <InputGroup className="mb-3">
                      <Input type="text" placeholder="City" innerRef={(input) => { this.cityInput = input }} />
                    </InputGroup>
                    <InputGroup className="mb-3">
                      <Input type="text" placeholder="Province" innerRef={(input) => { this.provinceInput = input }} />
                    </InputGroup>
                    <InputGroup className="mb-3">
                      <Input type="text" placeholder="Neighborhood" innerRef={(input) => { this.neighborhoodInput = input }} />
                    </InputGroup>
                    <InputGroup className="mb-3">
                      <Input type="text" placeholder="Street" innerRef={(input) => { this.streetInput = input }} />
                    </InputGroup>
                    <InputGroup className="mb-3">
                      <Input type="text" placeholder="Area Code" innerRef={(input) => { this.areaCodeInput = input }} />
                    </InputGroup>
                    <Button color="success" block>Submit</Button>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
      </div>
    )
  }

  setMessage(msg) {
    this.setState({
      message: msg,
      show: ''
    });
  }
}

export default Form;


// WEBPACK FOOTER //
// ./src/views/Locations/Form.js